<div class="c-network-request-chart">
	<style>
		{{#each providersJson}}
			.hits-chart-block_switchers_item_switch input.{{name}}:checked + .slider {
				background-color: {{color}};
			}

			.hits-chart-block_switchers_item_switch input.{{name}}:focus + .slider {
				box-shadow: 0 0 1px {{color}};
			}
		{{/each}}
	</style>

	<div class="chart-header">
		<h3>{{#if showChartBandwidth}}Bandwidth{{else}}Requests{{/if}} over time</h3>

		{{#unless noChartData}}
			<div class="chart-header_switch">
				<button class="button {{ showChartBandwidth ? '' : 'selected' }}" on-click="@this.set('showChartBandwidth', false)">Requests</button>
				<button class="button {{ showChartBandwidth ? 'selected' : '' }}" on-click="@this.set('showChartBandwidth', true)">Bandwidth</button>
			</div>
		{{/unless}}
	</div>


	{{#if noChartData}}
		<div class="hits-chart-no-data">
			<img
				width="270"
				height="148"
				src="{{@shared.assetsHost}}/img/landing/new/no-results.svg">
			<span>No data</span>
		</div>
	{{else}}
		<div class="hits-chart-block">
			<div class="hits-chart-block_switchers">
				<div class="hits-chart-block_switchers_breakdown">
					<div class="hits-chart-block_switchers_item">
						<label class="hits-chart-block_switchers_item_switch">
							<input
								type="checkbox"
								on-click="@this.toggle('showProviderBreakdown')"
								checked>
							<span class="slider round provider-breakdown {{#unless showProviderBreakdown}}provider-breakdown_turned-off{{/unless}}"></span>
							</label>
							<span class="hits-chart-block_switchers_item_name">Show provider breakdown</span>
					</div>
				</div>


				<div class="hits-chart-block_switchers_wrapper">
					{{#each switchList:index}}
						<div class="hits-chart-block_switchers_item {{#if switchList[index].disabled || !showProviderBreakdown}}disabled{{/if}}">
							<label class="hits-chart-block_switchers_item_switch">
								<input
									class="{{name}}"
									type="checkbox"
									on-click="@this.set('switchList['+@index+'].active', !active)"
									disabled="{{switchList[index].disabled || !showProviderBreakdown}}"
									checked="{{switchList[index].active}}">
								<span class="slider round"></span>
								</label>
								<span class="hits-chart-block_switchers_item_name">{{name}}</span>
						</div>
					{{/each}}
				</div>
			</div>

			<div class="hits-chart-block_chart-wrapper">
				<canvas id="hits-chart"></canvas>
			</div>
		</div>
	{{/if}}
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const initCharts = require('../../assets/js/utils/charts');
	const providersJson = require('../../assets/json/net-providers.json');
	const listeners = require('../../assets/js/utils/listeners');

	component.exports = {
		data () {
			return {
				showChartBandwidth: false,
				switchList: [],
				rawHitsChartData: '',
				providersJson,
				showProviderBreakdown: true,
				noChartData: null,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observe('period country continent __ready', function () {
					if (this.get('__ready')) {
						let period = this.get('period').periodValue;
						let country = this.get('country');
						let continent = this.get('continent');

						if (country === null) { country = ''; }

						if (continent === null) { continent = ''; }

						http.fetchNetworkProviderStats(period, country, continent).then((response) => {
							if (!response.hits.total && !response.bandwidth.total) {
								this.set('noChartData', true);
								this.set('switchList', []);
								this.set('rawHitsChartData', '');

								return;
							}

							let { providers: respProviders } = response.hits;

							let oldSwitchList = this.get('switchList');
							let newSwitchList = respProviders.map((provider) => {
								let oldOne = oldSwitchList.filter(one => one.name === providersJson[provider.code].name);

								return oldOne.length ? oldOne[0] : { name: providersJson[provider.code].name, active: true, shortName: provider.code };
							});

							this.set('noChartData', false);
							this.set('switchList', newSwitchList);
							this.set('rawHitsChartData', response);
						});
					}
				});

				this.observe('switchList', (switchList) => {
					let disabledSwitches = switchList.filter(s => s.active === false).length;
					let switchListLength = switchList.length;
					let updatedSwitchList = [];

					if (disabledSwitches === switchListLength - 1) {
						updatedSwitchList = switchList.map((switchItem) => {
							if (switchItem.active) {
								switchItem.disabled = true;
							} else {
								switchItem.disabled = false;
							}

							return switchItem;
						});
					} else {
						updatedSwitchList = switchList.map((switchItem) => {
							switchItem.disabled = false;

							return switchItem;
						});
					}

					this.set('switchList', updatedSwitchList);
				});

				this.observe('rawHitsChartData showChartBandwidth screenWidth switchList showProviderBreakdown', () => {
					let rawHitsChartData = this.get('rawHitsChartData');
					let switchList = this.get('switchList');

					if (!rawHitsChartData || switchList.length === 0) { return; }

					let chartPeriodType = this.get('period').periodType;
					let showChartBandwidth = this.get('showChartBandwidth');
					let showProviderBreakdown = this.get('showProviderBreakdown');
					let screenWidth = this.get('screenWidth') ? this.get('screenWidth') : window.innerWidth;
					let usageChartGroupBy = 'day';
					let hitsProviders = [ ...rawHitsChartData.hits.providers ];
					let bandwidthProviders = [ ...rawHitsChartData.bandwidth.providers ];
					let filteredHitsChartData = {};

					if (showProviderBreakdown) {
						let notActiveSwitches = [ ...switchList ].filter(s => s.active === false).map(s => s.shortName);

						notActiveSwitches.forEach((s) => {
							hitsProviders = hitsProviders.filter(p => p.code !== s);
							bandwidthProviders = bandwidthProviders.filter(p => p.code !== s);
						});

						filteredHitsChartData = {
							...rawHitsChartData,
							bandwidth: {
								...rawHitsChartData.bandwidth,
								providers: bandwidthProviders,
							},
							hits: {
								...rawHitsChartData.hits,
								providers: hitsProviders,
							},
						};
					} else {
						filteredHitsChartData = {
							...rawHitsChartData,
							bandwidth: this.combineProvidersData(bandwidthProviders),
							hits: this.combineProvidersData(hitsProviders),
						};
					}

					// collect X-Axis dates, group data by period, get
					let {
						labels,
						maxRangeValue,
						datasets,
						labelsStartEndPeriods,
						valueUnits,
					} = _.getPreparedProvidersDataForLineChart(filteredHitsChartData, usageChartGroupBy, chartPeriodType, showChartBandwidth);

					this.set('preparedHitsChartData', {
						datasets,
						labels,
						labelsStartEndPeriods,
						maxRangeValue,
						showChartBandwidth,
						yAxisPadding: screenWidth >= 768 ? 24 : 12,
						valueUnits,
						usageChartGroupBy,
					});
				}, { init: false });

				this.observe('showProviderBreakdown', (showProviderBreakdown) => {
					if (showProviderBreakdown === false) {
						let switchList = this.get('switchList');

						let updSwitchList = switchList.map(switchItem => ({
							...switchItem,
							active: true,
							disabled: true,
						}));

						this.set('switchList', updSwitchList);
					}
				});
			}
		},
		onrender () {
			let hitsChart;

			initCharts().then(({ createLineChart }) => {
				// create hits chart
				this.observe('preparedHitsChartData', (preparedHitsChartData) => {
					if (!preparedHitsChartData) { return; }

					let {
						datasets,
						labels,
						maxRangeValue,
						showChartBandwidth,
						yAxisPadding,
						labelsStartEndPeriods,
						valueUnits,
						usageChartGroupBy,
					} = preparedHitsChartData;
					let hitsChartCanvasEl = this.find('#hits-chart');

					if (!preparedHitsChartData || !hitsChartCanvasEl) { return; }

					if (hitsChart) {
						hitsChart.destroy();
						hitsChart = null;
					}

					let chartData = {
						labels,
						datasets,
						labelsStartEndPeriods,
						valueUnits,
						usageChartGroupBy,
					};
					let chartSettings = {
						useExternalTooltip: true,
						useImprovedTooltip: true,
						plugins: {
							useExternalTooltip: true,
						},
					};
					let maxRangeMagnitude = Math.floor(Math.log10(maxRangeValue));
					let chartConfig = {
						options: {
							scales: {
								x: {
									display: true,
									ticks: {
										autoSkip: false,
										color: '#5C667A',
										font: {
											size: 12,
											family: 'Lexend, sans-serif',
											lineHeight: 2,
										},
										callback (value) {
											let labelValue = this.getLabelForValue(value);

											if (labelValue.length) {
												return labelValue;
											}
										},
									},
									grid: {
										display: false,
									},
									border: {
										display: false,
									},
								},
								y: {
									display: true,
									min: 0,
									suggestedMax: Math.ceil(maxRangeValue / Math.pow(10, maxRangeMagnitude)) * Math.pow(10, maxRangeMagnitude),
									ticks: {
										padding: yAxisPadding,
										count: 9,
										color: '#5C667A',
										crossAlign: 'near',
										font: {
											size: 12,
											family: 'Lexend, sans-serif',
										},
										callback (value) {
											let valueByMagnitude = _.getValueByMagnitude(Math.round(value), 'round', 1, false);

											if (_.isMobileScreen()) {
												return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatToShortNumber(valueByMagnitude);
											}

											return showChartBandwidth ? `${_.formatNumber(valueByMagnitude)} ${valueUnits}` : _.formatNumber(valueByMagnitude);
										},
									},
									grid: {
										color: '#CFD6DD',
										tickLength: 0,
									},
									border: {
										display: false,
									},
								},
							},
						},
					};

					hitsChart = createLineChart(hitsChartCanvasEl, chartData, chartSettings, chartConfig);
				});
			});

			listeners.screenWidthListener(this);
		},
		combineProvidersData (providersList) {
			return providersList.reduce((res, currProvider) => {
				if (!res.providers) {
					res = {
						total: 0,
						prev: { total: 0 },
						providers: [
							{
								code: 'combinedProviders',
								dates: {},
								prev: { total: 0 },
								total: 0,
							},
						],
					};
				}

				Object.keys(currProvider.dates).forEach((dateKey) => {
					if (!res.providers[0].dates[dateKey]) {
						res.providers[0].dates[dateKey] = {
							total: 0,
						};
					}

					let currProviderDateValue = currProvider.dates[dateKey].total;

					res.providers[0].dates[dateKey].total += currProviderDateValue;
				});

				res.providers[0].total += currProvider.total;
				res.total += currProvider.total;
				res.providers[0].prev.total += currProvider.prev.total;
				res.prev.total += currProvider.prev.total;

				return res;
			}, {});
		},
	};
</script>
